import type { IAccordionRow } from '@klv/molecules/accordion/types';
import type { IFAQsSchema } from './types';

const finalizeFAQsSchema = (items: string[]): string => (`
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      ${items.join(',')}
    ]
  }
`);

const generateFAQsSchema = (rows: IAccordionRow[] = []): string[] => (
  rows.map((row: IAccordionRow) => (`{
    "@type": "Question",
    "name": "${row.title}",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "${row.content ? row.content.replace( /(<([^>]+)>)/ig, ' ').replace(/\s+/g, ' ').replaceAll('\n', '').replaceAll('"', '\\"').trim() : ''}"
    }
  }`))
);

const FAQsSchema = ({ components }: IFAQsSchema) => {
  const faqsSchema: string[] = [];

  components.forEach((component) => {
    if (component?.accordion?.isFaqsSection && component.accordion?.accordionItems) {
      faqsSchema.push(...generateFAQsSchema(component.accordion.accordionItems as IAccordionRow[]));
    }
  });

  if (faqsSchema.length) {
    return (
      <script type="application/ld+json">{finalizeFAQsSchema(faqsSchema)}</script>
    );
  }

  return null;
};

export default FAQsSchema;
